module.exports = __webpack_public_path__ + "img/reportedIssueSolving.614925a4.svg";